// src/store/aiTip/aiTipThunk.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAITipsAPI,
  getTipByIdAPI,
  submitTipFeedbackAPI,
  createTipAPI
} from './aiTipAPI';

// Fetch AI tips
export const fetchAITips = createAsyncThunk(
  'aiTip/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await getAITipsAPI(params);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch AI tips'
      );
    }
  }
);

// Fetch tip by ID
export const fetchTipById = createAsyncThunk(
  'aiTip/fetchById',
  async (tipId, { rejectWithValue }) => {
    try {
      const response = await getTipByIdAPI(tipId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch tip'
      );
    }
  }
);

// Submit tip feedback
export const submitTipFeedback = createAsyncThunk(
  'aiTip/submitFeedback',
  async ({ tipId, feedbackData }, { rejectWithValue }) => {
    try {
      const response = await submitTipFeedbackAPI(tipId, feedbackData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to submit feedback'
      );
    }
  }
);

// Create new tip (Admin)
export const createTip = createAsyncThunk(
  'aiTip/create',
  async (tipData, { rejectWithValue }) => {
    try {
      const response = await createTipAPI(tipData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to create tip'
      );
    }
  }
);